import { postRequest, getRequest } from '../../../../../hooks/axiosClient';

export const saveNavigationPaths = (projectId, floorplanId, paths) => {
    // return postRequest('project-navigation', {
    //     project_id:   projectId,
    //     floorplan_id: floorplanId,
    //     paths:        JSON.stringify(paths),
    // });
    return postRequest('update-pointedges', {
        id: floorplanId,
        points_data: paths,
        edges_data: null,
        highlight_data: null,
        sub_node: null,
        connected_nodes: null,
        auto_connected_nodes: null,
        is_published: "0",
        discard: "1",
        publish: "1"
        
    });
};

export const loadNavPathsFromProject = async (projectId) => {
    const response  = await getRequest(`project/${projectId}`);
    const fpDetails = response?.data?.fp_details;
    if (!Array.isArray(fpDetails) || fpDetails.length === 0) return [];
    
    const allPaths = [];
    
    for (const floor of fpDetails) { 
        const floorId = floor.fp_id;
        if (!floorId) continue;
        
        const raw = floor.points_data;
        if (!raw) continue;
        
        try {
            const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
            if (Array.isArray(parsed)) {
                allPaths.push(...parsed.map((p) => ({ ...p, floorId })));
            }
        } catch {}
    }
    return allPaths;
};
